import { render } from "./General_Receipts.vue?vue&type=template&id=93890e74&scoped=true"
import script from "./General_Receipts.vue?vue&type=script&lang=js"
export * from "./General_Receipts.vue?vue&type=script&lang=js"

import "./General_Receipts.vue?vue&type=style&index=0&id=93890e74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93890e74"]])

export default __exports__